import React from 'react';

import { isOpen } from '../utils/sopUtils';

import { useUser } from './User';
import { useParams } from 'react-router-dom';
import spacetime from 'spacetime';
import { sorts } from '../utils';

const UserSop = () => {
    const params = useParams();
    const { sop } = useUser(params.user_id);
    const sortedSubs = [...sop];
    sortedSubs.sort((a, b) => sorts.desc(a.last_submitted, b.last_submitted));
    return (
        <div>
            <h2>SOP Subscriptions</h2>
            <hr />
            {sop.length && (
                <table className="table">
                    <thead>
                        <tr>
                            <th>NetSuite ID</th>
                            <th>Subscription</th>
                            <th>Quantity</th>
                            <th>Contact</th>
                            <th>Submitted?</th>
                            <th>Last Submit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedSubs.map((sub) => {
                            let lastSubmit = sub.last_submitted ? spacetime(sub.last_submitted) : null;
                            return (
                                <tr key={sub.internal_id}>
                                    <th>{sub.internal_id}</th>
                                    <td>{sub.description}</td>
                                    <td>
                                        {sub.quantity} {sub.frequencytype}
                                    </td>
                                    <td>
                                        {sub.contact.contactname} &lt;{sub.contact.email}&gt;
                                    </td>
                                    <td>{!isOpen(sub) ? 'yes' : 'no'}</td>
                                    <td>{lastSubmit ? lastSubmit.format('numeric-us') : 'n/a'}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
            <div className="row">
                {!sop.length && (
                    <p>
                        <strong>No SOP Subscriptions</strong>
                    </p>
                )}
            </div>
        </div>
    );
};

export default UserSop;
